import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import authService from '../../services/auth';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    authService.logout();
    setIsLoggedIn(false);
    navigate('/');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClick = (e, sectionId) => {
    e.preventDefault();
    
    // Close mobile menu if open
    setIsMenuOpen(false);
    
    // If we're not on the landing page, navigate there first
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      // We're already on landing page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className="ud-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <nav className="navbar navbar-expand-lg">
              <Link className="navbar-brand" to="/">
                <img 
                  src="/assets/images/logo/image.png" 
                  alt="NovaMatch Logo" 
                  style={{ 
                    height: '50px',
                    backgroundColor: 'white',
                    padding: '8px 15px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }} 
                />
              </Link>
              <button className={`navbar-toggler ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                <span className="toggler-icon"></span>
                <span className="toggler-icon"></span>
                <span className="toggler-icon"></span>
              </button>

              <div className={`navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
                <ul id="nav" className="navbar-nav mx-auto">
                  <li className="nav-item">
                    <a className="ud-menu-scroll" href="/#home" onClick={(e) => handleMenuClick(e, 'home')}>Home</a>
                  </li>
                  <li className="nav-item">
                    <a className="ud-menu-scroll" href="/#how-it-works" onClick={(e) => handleMenuClick(e, 'how-it-works')}>How It Works</a>
                  </li>
                  <li className="nav-item">
                    <a className="ud-menu-scroll" href="/#features" onClick={(e) => handleMenuClick(e, 'features')}>Features</a>
                  </li>
                  <li className="nav-item">
                    <a className="ud-menu-scroll" href="/#who-for" onClick={(e) => handleMenuClick(e, 'who-for')}>Who Is It For</a>
                  </li>
                  <li className="nav-item">
                    <a className="ud-menu-scroll" href="/#subscription" onClick={(e) => handleMenuClick(e, 'subscription')}>Subscription</a>
                  </li>
                  <li className="nav-item">
                    <a className="ud-menu-scroll" href="/#contact" onClick={(e) => handleMenuClick(e, 'contact')}>Contact</a>
                  </li>
                </ul>
                {/* Mobile menu buttons */}
                <div className="d-sm-none mobile-menu-buttons" style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '10px', 
                  padding: '15px 20px 10px 20px',
                  borderTop: '1px solid #e2e8f0',
                  marginTop: '15px'
                }}>
                  {isLoggedIn ? (
                    <>
                      <Link 
                        to="/app" 
                        className="ud-main-btn ud-white-btn"
                        style={{ width: '100%', textAlign: 'center' }}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Dashboard
                      </Link>
                      <button 
                        onClick={() => { handleLogout(); setIsMenuOpen(false); }} 
                        className="ud-main-btn ud-login-btn"
                        style={{ width: '100%' }}
                      >
                        Logout
                      </button>
                    </>
                  ) : (
                    <>
                      <Link 
                        to="/login" 
                        className="ud-main-btn ud-login-btn"
                        style={{ width: '100%', textAlign: 'center' }}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Sign In
                      </Link>
                      <Link 
                        to="/register" 
                        className="ud-main-btn ud-white-btn"
                        style={{ width: '100%', textAlign: 'center' }}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Create Account
                      </Link>
                    </>
                  )}
                </div>
              </div>

              <div className="navbar-btn d-none d-sm-inline-block">
                {isLoggedIn ? (
                  <>
                    <Link to="/app" className="ud-main-btn ud-white-btn">
                      Dashboard
                    </Link>
                    <button onClick={handleLogout} className="ud-main-btn ud-login-btn">
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="ud-main-btn ud-login-btn">
                      Sign In
                    </Link>
                    <Link to="/register" className="ud-main-btn ud-white-btn">
                      Create Account
                    </Link>
                  </>
                )}
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
